<template>
    <perfect-scrollbar class="wrapper">
        <ul>
            <li>
                <router-link to="/job/start" @click.native="hideMobileMenu()">
                    <b-icon icon="card-text"></b-icon>
                    <span>เปิดใบงาน</span>
                </router-link>
            </li>
            <li>
                <router-link to="/job/list" @click.native="hideMobileMenu()">
                    <b-icon icon="journal-text"></b-icon>
                    <span>รายการใบงาน</span>
                </router-link>
            </li>
            <li>
                <router-link to="/schedule" @click.native="hideMobileMenu()">
                    <b-icon icon="calendar2-event"></b-icon>
                    <span>รายการนัดหมาย</span>
                </router-link>
            </li>
            <li>
                <router-link to="/prospect" @click.native="hideMobileMenu()">
                    <b-icon icon="info-square"></b-icon>
                    <span>เก็บข้อมูลสอบถาม</span>
                </router-link>
            </li>
            <li>
                <router-link to="/supplier" @click.native="hideMobileMenu()">
                    <b-icon icon="shop-window"></b-icon>
                    <span>รายชื่อซัพพลายเออร์</span>
                </router-link>
            </li>
            <li>
                <router-link to="/inventory" @click.native="hideMobileMenu()">
                    <b-icon icon="box-seam"></b-icon>
                    <span>สต๊อคสินค้า</span>
                </router-link>
            </li>
            <li>
                <router-link to="/service" @click.native="hideMobileMenu()">
                    <b-icon icon="tools"></b-icon>
                    <span>บริการอื่นๆ</span>
                </router-link>
            </li>
            <li>
                <router-link to="/customer" @click.native="hideMobileMenu()">
                    <b-icon icon="person"></b-icon>
                    <span>ข้อมูลลูกค้า</span>
                </router-link>
            </li>
            <li>
                <router-link to="/fleet" @click.native="hideMobileMenu()">
                    <b-icon icon="people"></b-icon>
                    <span>ลูกค้าฟลีต</span>
                </router-link>
            </li>
            <li>
                <router-link to="/accounting" @click.native="hideMobileMenu()">
                    <b-icon icon="clipboard"></b-icon>
                    <span>รายการบัญชี</span>
                </router-link>
            </li>
            <li>
                <router-link to="/store" @click.native="hideMobileMenu()">
                    <b-icon icon="shop-window"></b-icon>
                    <span>ข้อมูลร้านค้า</span>
                </router-link>
            </li>
            <li>
                <router-link to="/report" @click.native="hideMobileMenu()">
                    <b-icon icon="book"></b-icon>
                    <span>รายงานการขาย</span>
                </router-link>
            </li>
            <li>
                <button @click="logout()">
                    <b-icon icon="box-arrow-right"></b-icon>
                    <span>ออกจากระบบ</span>
                </button>
            </li>
        </ul>
    </perfect-scrollbar>
</template>

<script>
export default {
    methods: {
        hideMobileMenu() {
            this.$root.$emit('rootHideMobileMenu');
        },
        logout() {
            this.$AppUtility.renderLoadBackdrop();

            localStorage.token = '';
            localStorage.profileName = '';

            location.href = "/";
        }
    }
}
</script>